import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavBar, Icon, ListView, Card, WingBlank, WhiteSpace, Picker, List, Button, Modal, InputItem, Toast, Badge, ActionSheet, Checkbox, DatePicker } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import QRCode from 'qrcode.react';
import DataFetcher from '../utils/DataFetcher';
import { createForm } from 'rc-form';
import '../styles/AgentCoupon.css';
import CommonUtils from '../utils/CommonUtils';
import Constants from '../utils/Constants';

const history = require("history").createHashHistory()
const CheckboxItem = Checkbox.CheckboxItem;

class AgentCoupon extends Component {
    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4,
            enableCreate: true,
            enableUpdate: true,
            enablePermission: true,
            showCreateModal: false,
            showUpdateModal: false,
            showQRCodeModal: false,
            showPermissionModal: false,
            selectedItem: null,
            agentSites: [],
            organizations: [],
            selectedCouponType: null,
            deviceTypes: []
        }
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 65;
        this.setState({
            height
        })
        this.loadDeviceTypes()
        this.loadOrganizations()
        this.loadAgentSites(() => {
            this.loadPageData(1, height)
        })
    }

    loadPageData = (pageNum) => {
        DataFetcher.agentActivities({
            pageNum,
            pageSize: 10,
        }, {
            success: (resp) => {
                let data = resp.data
                this.pageNum = data.pageNum;
                this.pageSize = data.pageSize;
                this.pages = data.pages;
                let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : {}
                this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
                this.setState({
                    dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                    isLoading: false,
                    hasMore: this.pageNum < this.pages,
                })
            }
        })
    }

    loadAgentSites = (callback) => {
        DataFetcher.agentSites((resp) => {
            this.setState({
                agentSites: resp.data,
                selectedSite: resp.data[0]?resp.data[0].id:null
            }, () => {
                callback&&callback()
            })
        })
    }

    loadDeviceTypes = () => {
        DataFetcher.deviceTypes({}, {
            success: (resp) => {
                this.setState({
                    deviceTypes: resp.data
                })
            }
        })
    }

    loadOrganizations = () => {
        DataFetcher.topOrganizations({
        }, {
            success: (resp) => {
                this.setState({
                    organizations: resp.data
                })
            }
        })
    }

    onEndReached = (event) => {
        const { isLoading, hasMore } = this.state

        if (isLoading || !hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadPageData(++this.pageNum)
    }

    onSitePickerChange = (val) => {
        this.setState({
            selectedSite: val[0]
        }, () => {
            this.loadPageData(1)
        })
    }

    onCouponTypeChange = (val) => {
        console.log('coupon type: ' + val[0])
        this.setState({
            selectedCouponType: val[0]
        })
    }

    isSiteChecked = (record, siteId) => {
        if(!record||!record.siteIds||!record.siteIds.length) return false

        if(record.siteIds.indexOf(siteId) >= 0) {
            return true
        }
        return false
    } 

    isOrganizationChecked = (record, organizationId) => {
        if(!record||!record.organizationIds||!record.organizationIds.length) return false

        if(record.organizationIds.indexOf(organizationId) >= 0) {
            return true
        }
        return false
    } 

    handleItemClick = (rowData) => {
        const options = [
            { icon: <i className='iconfont icon-xiugai' style={{color:'#04bbc5', fontSize: 30}}/>, title: '编辑信息' },
            { icon: <i className='iconfont icon-group-chat' style={{color:'green', fontSize: 30}}/>, title: '领券记录' }
        ]
        if(rowData.grabWay === 'PAPER_COUPON') {
            options.push({ icon: <i className='iconfont icon-daochu' style={{color:'orange', fontSize: 30}}/>, title: '券码' })
        } else if(rowData.grabWay === 'ONLINE_QRCODE') {
            options.push({ icon: <i className='iconfont icon-erweima' style={{color:'orange', fontSize: 35}}/>, title: '活动码' })
        } else if(rowData.grabWay === 'OFFLINE_QRCODE') {
            options.push({ icon: <i className='iconfont icon-quanxian' style={{color:'orange', fontSize: 30}}/>, title: '发券权限' })
        }
        
        let optionMap = {}
        for(let i = 0; i < options.length; i++) {
            optionMap[i] = options[i].title
        }
        ActionSheet.showShareActionSheetWithOptions({
            options,
            title: '操作',
            message: rowData.name,
        },
        (buttonIndex) => {
            let buttonTitle = optionMap[buttonIndex]
            if(!buttonTitle) return

            if(buttonTitle === '编辑信息') {
                this.setState({
                    showUpdateModal: true,
                    selectedItem: rowData
                })
            } else if(buttonTitle === '领券记录') {
                history.push(`/agent/coupon_grabbed?activityId=${rowData.id}`)
            } else if(buttonTitle === '券码') {
                history.push(`/agent/coupon_codes/${rowData.id}`)
            } else if(buttonTitle === '活动码') {
                this.setState({
                    showQRCodeModal: true,
                    selectedItem: rowData
                })
            } else if(buttonTitle === '发券权限') {
                this.setState({
                    showPermissionModal: true,
                    selectedItem: rowData
                })
            } else {
                Toast.info('功能开发中')
            }
        });
    }

    handleCreateClick = () => {
        if(!this.state.enableCreate) {
            return
        }

        this.setState({
            enableCreate: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            let siteIds = []
            for(let prop in fieldsValue) {
                if(prop.indexOf('create_siteIds_') !== 0) {
                    continue
                }

                let siteId = prop.substring('create_siteIds_'.length)
                if(fieldsValue[prop]) {
                    siteIds.push(siteId)
                }
            }

            const params = {}
            for(let prop in fieldsValue) {
                if(prop.indexOf('create_') !== 0) {
                    continue
                }
                let propValue = fieldsValue[prop]
                if(Array.isArray(propValue)) {
                    propValue = propValue[0]
                }
                params[prop.substring('create_'.length)] = propValue               
            }
            params.siteIds = siteIds
            params.startTime = CommonUtils.dateToString(params.startTime)
            params.endTime = CommonUtils.dateToString(params.endTime)

            DataFetcher.createActivity(params, {
                success: (resp) => {
                    this.setState({
                        showCreateModal: false
                    })
                    this.props.form.resetFields()
                    this.loadPageData(1)
                },
                completed: () => {
                    this.setState({
                        enableCreate: true
                    })
                }
            })
        });
    }

    handleUpdateClick = () => {
        const { selectedItem } = this.state
        if(!selectedItem) return

        if(!this.state.enableUpdate) {
            return
        }

        this.setState({
            enableUpdate: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            let siteIds = []
            for(let prop in fieldsValue) {
                if(prop.indexOf('update_siteIds_') !== 0) {
                    continue
                }

                let siteId = prop.substring('update_siteIds_'.length)
                if(fieldsValue[prop]) {
                    siteIds.push(siteId)
                }
            }

            const params = {
                id: selectedItem.id
            }
            for(let prop in fieldsValue) {
                if(prop.indexOf('update_') !== 0) {
                    continue
                }
                let propValue = fieldsValue[prop]
                if(Array.isArray(propValue)) {
                    propValue = propValue[0]
                }
                params[prop.substring('update_'.length)] = propValue               
            }
            params.siteIds = siteIds
            params.startTime = CommonUtils.dateToString(params.startTime)
            params.endTime = CommonUtils.dateToString(params.endTime)

            DataFetcher.updateActivity(params, {
                success: (resp) => {
                    this.setState({
                        showUpdateModal: false
                    })
                    this.props.form.resetFields()
                    this.loadPageData(1)
                },
                completed: () => {
                    this.setState({
                        enableUpdate: true
                    })
                }
            })
        });
    }

    handlePermissionClick = () => {
        const { selectedItem } = this.state
        if(!selectedItem) return

        if(!this.state.enablePermission) {
            return
        }

        this.setState({
            enablePermission: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            let organizationIds = []
            for(let prop in fieldsValue) {
                if(prop.indexOf('permission_organizationIds_') !== 0) {
                    continue
                }

                let organizationId = prop.substring('permission_organizationIds_'.length)
                if(fieldsValue[prop]) {
                    organizationIds.push(organizationId)
                }
            }

            const params = {
                activityId: selectedItem.id,
                organizationIds
            }

            DataFetcher.updateActivityPermission(params, {
                success: (resp) => {
                    this.setState({
                        showPermissionModal: false
                    })
                    this.props.form.resetFields()
                    this.loadPageData(1)
                },
                completed: () => {
                    this.setState({
                        enablePermission: true
                    })
                }
            })
        });
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.forEach((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
        })
        return rowDatas;
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    generateInfoColumnForCouponType = (rowData) => {
        if(rowData.couponType === 'GAME_MINUTES') {
            return (
                <div className='info-column word-ellipsis'>
                    <span className='label'>游戏时间：</span> 
                    <span className='value'>{rowData.gameMinutes}分钟</span>
                </div>
            )
        } else if(rowData.couponType === 'PACKET_DISCOUNT') {
            return (
                <div className='info-column word-ellipsis'>
                    <span className='label'>套餐折扣：</span> 
                    <span className='value'>{rowData.discount}%</span>
                </div>
            )
        } else {
            return (
                <div className='info-column word-ellipsis'>
                    <span className='label'>适用门店：</span> 
                    <span className='value'>{rowData.siteNames?rowData.siteNames.join(','):''}</span>
                </div>
            )
        }
    }

    generateCreateFormItem = () => {
        const { getFieldProps } = this.props.form;
        const { selectedCouponType } = this.state

        if(selectedCouponType === 'PACKET_DISCOUNT') {
            return (
                <div>
                    <InputItem type='number' extra="%" placeholder='1~100' {...getFieldProps('create_discount', {
                            rules: [{required: true, message: '请填写套餐折扣'}],
                        })}>
                        套餐折扣
                    </InputItem>
                    <InputItem type='digit' extra="元" placeholder='优惠券适用的最低套餐价' {...getFieldProps('create_bottomAmount', {
                    })}>
                        最低套餐
                    </InputItem>
                    <InputItem type='digit' extra="元" placeholder='优惠券适用的最高套餐价' {...getFieldProps('create_topAmount', {
                    })}>
                        最高套餐
                    </InputItem>
                </div>
            )
        } else {
            return (
                <InputItem type='number' extra="分" {...getFieldProps('create_gameMinutes', {
                    rules: [{required: true, message: '请填写游戏时间'}],
                })}>
                    游戏时间
                </InputItem>
            )
        }
    }

    generateUpdateFormItem = () => {
        const { getFieldProps } = this.props.form;
        const { selectedItem } = this.state
        let couponType = selectedItem ? selectedItem.couponType : null

        if(couponType === 'PACKET_DISCOUNT') {
            return (
                <div>
                    <InputItem type='number' extra="%" placeholder='1~100' {...getFieldProps('update_discount', {
                            initialValue: selectedItem?selectedItem.discount:null,
                            rules: [{required: true, message: '请填写套餐折扣'}],
                        })}>
                        套餐折扣
                    </InputItem>
                    <InputItem type='digit' extra="元" placeholder='优惠券适用的最低套餐价' {...getFieldProps('update_bottomAmount', {
                        initialValue: selectedItem?selectedItem.bottomAmount:null,
                    })}>
                        最低套餐
                    </InputItem>
                    <InputItem type='digit' extra="元" placeholder='优惠券适用的最高套餐价' {...getFieldProps('update_topAmount', {
                        initialValue: selectedItem?selectedItem.topAmount:null,
                    })}>
                        最高套餐
                    </InputItem>
                </div>
            )
        } else {
            return (
                <InputItem type='number' extra="分" {...getFieldProps('update_gameMinutes', {
                    initialValue: selectedItem?selectedItem.gameMinutes:null,
                    rules: [{required: true, message: '请填写游戏时间'}],
                })}>
                    游戏时间
                </InputItem>
            )
        }
    }

    renderRow = (rowData, sectionId, rowId) => {
        let progressText = Constants.DICT_ACTIVITY_PROGRESS[rowData.progress]
        let progressColor = 'gray'
        if(rowData.progress === 'ONGOING') {
            progressColor = '#04bbc5'
        }
        let tagBadge = (<Badge text={progressText} style={{backgroundColor: progressColor}}/>)
        return (
            <WingBlank size='sm'>
                <div onClick={() => {this.handleItemClick(rowData)}}>
                    <Card key={rowId}>
                        <Card.Header
                            title={<span className='word-ellipsis'>{rowData.name}</span>}
                            extra={tagBadge}
                        />
                        <Card.Body>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>已用/已领：</span> 
                                    <span className='value'>{rowData.exchangedCount}/{rowData.toExchangeCount+rowData.exchangedCount}</span>
                                </div>
                                {this.generateInfoColumnForCouponType(rowData)}
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>优惠券数：</span> 
                                    <span className='value'>{rowData.quantity}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>用户限领：</span> 
                                    <span className='value'>{rowData.limitPerUser}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>优惠类型：</span> 
                                    <span className='value'>{Constants.DICT_COUPON_TYPE[rowData.couponType]}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>领券方式：</span> 
                                    <span className='value'>{Constants.DICT_COUPON_GRAB_WAY[rowData.grabWay]}</span>
                                </div>
                            </div>
                        </Card.Body>
                        <Card.Footer content={<span className='word-ellipsis'>{CommonUtils.resolveDictText(rowData.deviceType, this.state.deviceTypes, 'code', 'name')}</span>} extra={<span className='word-ellipsis'>{CommonUtils.shortenDateTime(rowData.startTime)} ~ {CommonUtils.shortenDateTime(rowData.endTime)}</span>}/>
                    </Card>
                </div>
            </WingBlank>
        )
    }

    doRenderCreateModal = () => {
        const { getFieldProps } = this.props.form;
        const { showCreateModal, enableCreate, agentSites } = this.state
        let defaultStartTime = new Date()
        let defaultEndTime = new Date()
        defaultEndTime.setDate(defaultStartTime.getDate() + 30)

        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showCreateModal}
                    onClose={() => {
                        this.setState({showCreateModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" style={{maxHeight: 500, overflow: 'scroll'}} renderHeader={() => <div className='modal-title'>新建活动</div>}>
                        <InputItem {...getFieldProps('create_name', {})}>
                            活动名称
                        </InputItem>
                        <Picker 
                            cols={1}
                            data={CommonUtils.generatePickerOptions(Constants.DICT_COUPON_TYPE)}
                            {...getFieldProps('create_couponType', {
                                initialValue: ['GAME_MINUTES'],
                                onChange: this.onCouponTypeChange,
                                rules: [{required: true, message: '请选择优惠类型'}],
                            })} 
                        >
                            <List.Item arrow="horizontal">优惠类型</List.Item>
                        </Picker>
                        <Picker 
                            cols={1}
                            data={CommonUtils.generatePickerOptionsFromList(this.state.deviceTypes, 'code', 'name')}
                            {...getFieldProps('create_deviceType', {
                                initialValue: ['PC'],
                                rules: [{required: true, message: '请选择设备类型'}],
                            })} 
                        >
                            <List.Item arrow="horizontal">设备类型</List.Item>
                        </Picker>
                        <Picker 
                            cols={1}
                            data={CommonUtils.generatePickerOptions(Constants.DICT_COUPON_GRAB_WAY)}
                            {...getFieldProps('create_grabWay', {
                                initialValue: ['ONLINE_QRCODE'],
                                rules: [{required: true, message: '请选择领券方式'}],
                            })} 
                        >
                            <List.Item arrow="horizontal">领券方式</List.Item>
                        </Picker>
                        <DatePicker mode='datetime' {...getFieldProps('create_startTime', {
                            initialValue: defaultStartTime,
                            rules: [{required: true, message: '请选择开始时间'}],
                        })}>
                            <List.Item arrow="horizontal">开始时间</List.Item>
                        </DatePicker>
                        <DatePicker mode='datetime' {...getFieldProps('create_endTime', {
                            initialValue: defaultEndTime,
                            rules: [{required: true, message: '请选择结束时间'}],
                        })}>
                            <List.Item arrow="horizontal">结束时间</List.Item>
                        </DatePicker>
                        <InputItem type='number' extra="张" {...getFieldProps('create_quantity', {
                            initialValue: 100,
                            rules: [{required: true, message: '请填写优惠券数'}],
                        })}>
                            优惠券数
                        </InputItem>
                        <InputItem type='number' extra="张" placeholder='每个用户最多可领的优惠券数' {...getFieldProps('create_limitPerUser', {
                            initialValue: 1,
                            rules: [{required: true, message: '请填写用户限领'}],
                        })}>
                            用户限领
                        </InputItem>
                        {this.generateCreateFormItem()}
                        <InputItem {...getFieldProps('create_description', {
                        })}>
                            活动描述
                        </InputItem>
                        <List.Item>
                            <div style={{fontSize: 17, color: '#555', width: '100%'}}>适用门店</div>
                        </List.Item>
                        <div className='site-select'>
                            {agentSites.map(item => (
                                <CheckboxItem key={item.id}
                                    {...getFieldProps('create_siteIds_' + item.id, {
                                    })}
                                >
                                    {item.siteName}
                                </CheckboxItem>
                            ))}
                        </div>
                        <List.Item>
                            <Button type="primary" onClick={this.handleCreateClick} disabled={!enableCreate}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderUpdateModal = () => {
        const { getFieldProps } = this.props.form;
        const { showUpdateModal, enableUpdate, selectedItem, agentSites } = this.state
        
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showUpdateModal}
                    onClose={() => {
                        this.setState({showUpdateModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" style={{maxHeight: 500}} renderHeader={() => <div className='modal-title'>编辑信息</div>}>
                        <InputItem {...getFieldProps('update_name', {
                            initialValue: selectedItem?selectedItem.name:null,
                        })}>
                            活动名称
                        </InputItem>
                        <InputItem disabled {...getFieldProps('update_couponType', {
                            initialValue: selectedItem?Constants.DICT_COUPON_TYPE[selectedItem.couponType]:null,
                        })}>
                            优惠类型
                        </InputItem>
                        <InputItem disabled {...getFieldProps('update_deviceType', {
                            initialValue: selectedItem?CommonUtils.resolveDictText(selectedItem.deviceType, this.state.deviceTypes, 'code', 'name'):null,
                        })}>
                            设备类型
                        </InputItem>
                        <Picker 
                            cols={1}
                            data={CommonUtils.generatePickerOptions(Constants.DICT_COUPON_GRAB_WAY)}
                            {...getFieldProps('update_grabWay', {
                                initialValue: selectedItem?[selectedItem.grabWay]:[],
                                rules: [{required: true, message: '请选择领券方式'}],
                            })} 
                        >
                            <List.Item arrow="horizontal">领券方式</List.Item>
                        </Picker>
                        <DatePicker mode='datetime' {...getFieldProps('update_startTime', {
                            initialValue: selectedItem?CommonUtils.stringToDate(selectedItem.startTime):null,
                            rules: [{required: true, message: '请选择开始时间'}],
                        })}>
                            <List.Item arrow="horizontal">开始时间</List.Item>
                        </DatePicker>
                        <DatePicker mode='datetime' {...getFieldProps('update_endTime', {
                            initialValue: selectedItem?CommonUtils.stringToDate(selectedItem.endTime):null,
                            rules: [{required: true, message: '请选择结束时间'}],
                        })}>
                            <List.Item arrow="horizontal">结束时间</List.Item>
                        </DatePicker>
                        <InputItem type='number' extra="张" {...getFieldProps('update_quantity', {
                            initialValue: selectedItem?selectedItem.quantity:null,
                            rules: [{required: true, message: '请填写优惠券数'}],
                        })}>
                            优惠券数
                        </InputItem>
                        <InputItem type='number' extra="张" placeholder='每个用户最多可领的优惠券数' {...getFieldProps('update_limitPerUser', {
                            initialValue: selectedItem?selectedItem.limitPerUser:null,
                            rules: [{required: true, message: '请填写用户限领'}],
                        })}>
                            用户限领
                        </InputItem>
                        {this.generateUpdateFormItem()}
                        <InputItem {...getFieldProps('update_description', {
                            initialValue: selectedItem?selectedItem.description:null,
                        })}>
                            活动描述
                        </InputItem>
                        <List.Item>
                            <div style={{fontSize: 17, color: '#555', width: '100%'}}>适用门店</div>
                        </List.Item>
                        <div className='site-select'>
                            {agentSites.map(item => (
                                <CheckboxItem key={item.id} defaultChecked={this.isSiteChecked(selectedItem, item.id)}
                                    {...getFieldProps('update_siteIds_' + item.id, {
                                        initialValue: this.isSiteChecked(selectedItem, item.id)
                                    })}
                                >
                                    {item.siteName}
                                </CheckboxItem>
                            ))}
                        </div>
                        <List.Item>
                            <Button type="primary" onClick={this.handleUpdateClick} disabled={!enableUpdate}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderQRCodeModal = () => {
        const { showQRCodeModal, selectedItem } = this.state
        
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showQRCodeModal}
                    onClose={() => {
                        this.setState({showQRCodeModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title word-ellipsis' style={{maxWidth: '60%', margin: '0 auto'}}>活动码 - {selectedItem?selectedItem.name:''}</div>}>
                        <div style={{textAlign: 'center', wdith: '100%', paddingTop: 20, paddingBottom: 10}}>
                            <QRCode value={selectedItem?selectedItem.activityQRCode:''} size={200}/>
                        </div>
                        <div style={{width: '100%', textAlign: 'center', color: 'gray', paddingBottom: 20}}>请截图保存二维码</div>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderPermissionModal = () => {
        const { getFieldProps } = this.props.form;
        const { showPermissionModal, enablePermission, selectedItem, organizations } = this.state
        
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showPermissionModal}
                    onClose={() => {
                        this.setState({showPermissionModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" style={{maxHeight: 500}} renderHeader={() => <div className='modal-title'>发券权限</div>}>
                        <InputItem disabled {...getFieldProps('permission_name', {
                            initialValue: selectedItem?selectedItem.name:null,
                        })}>
                            活动名称
                        </InputItem>
                        <List.Item>
                            <div style={{fontSize: 17, color: '#555', width: '100%'}}>发券商</div>
                        </List.Item>
                        <div className='custom-select'>
                            {organizations.map(item => (
                                <CheckboxItem key={item.id} defaultChecked={this.isOrganizationChecked(selectedItem, item.id)}
                                    {...getFieldProps('permission_organizationIds_' + item.id, {
                                        initialValue: this.isOrganizationChecked(selectedItem, item.id)
                                    })}
                                >
                                    {item.name}
                                </CheckboxItem>
                            ))}
                        </div>
                        <List.Item>
                            <Button type="primary" onClick={this.handlePermissionClick} disabled={!enablePermission}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    render() {
        const { dataSource, isLoading } = this.state;

        return (
            <div className='page-agent-coupon'>
                <NavBar 
                    mode="light" 
                    icon={<Icon type="left" color="black" size="md"/>} 
                    onLeftClick={history.goBack}
                    rightContent={<i className='iconfont icon-tianjia' style={{color:'black'}} onClick={() => {this.setState({showCreateModal: true})}}></i>}
                >
                    优惠活动
                </NavBar>
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => this.renderFooter(isLoading)}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                        paddingTop: 50
                    }}
                />
                {this.doRenderCreateModal()}
                {this.doRenderUpdateModal()}
                {this.doRenderQRCodeModal()}
                {this.doRenderPermissionModal()}
            </div>
        )
    }
}

export default createForm()(AgentCoupon);


// WEBPACK FOOTER //
// ./src/modules/AgentCoupon.js